export const getSegment = (state) => state.segments;
